import "@nudgebox/ui/tokens.stylex";
import { color, font } from "@nudgebox/ui/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { Outlet } from "@tanstack/react-router";
import { NavigationProgress } from "./route-pending.tsx";

/**
 * Theme the document body itself (not just the React root) so portaled UI —
 * dialogs, menus, toasts — inherits the same font and colors.
 */
export function applyDocumentTheme() {
  const {
    className
  } = {
    className: "xg6iff7 xvccuex x9aqtqa x1wv6yj"
  };
  if (className) document.body.classList.add(...className.split(" "));
  // StyleX's `::selection` only matches an element's own text, not its
  // descendants', so the selection highlight is a single global rule. It
  // reads the token variable, so it follows the active theme.
  const selection = document.createElement("style");
  selection.textContent = `::selection { background-color: ${color.accentSoft}; color: ${color.textPrimary}; }`;
  document.head.append(selection);
}
export function RootLayout() {
  return <>
      <NavigationProgress />
      <Outlet />
    </>;
}